// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { ReactElement, ReactNode } from 'react';

import { App, type MyAppProps } from '@crehana/next';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { NextPage } from 'next';

import 'nprogress/nprogress.css';
import '@crehana/next/dist/main.css';
import '@crehana/ui/dist/crehana-ui.min.css';
import '../../styles/globals.css';

type NextPageWithLayout = NextPage & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = MyAppProps & {
  Component: NextPageWithLayout;
};

const MyApp: React.FC<AppPropsWithLayout> = props => {
  const getLayout = props.Component.getLayout ?? (page => page);
  const _pageProps = { ...props.pageProps, disabledShoppingCart: true };

  return (
    <App
      {...props}
      customRender={({ Component }) => {
        return getLayout(<Component err={props.err} {..._pageProps} />);
      }}
      pageProps={{
        ...props.pageProps,
        disabledShoppingCart: true,
      }}
    />
  );
};

export default MyApp;
